import React from "react";
import { useGeoLocation } from "../../hooks/useGeoLocation";
import SectionHeading from "../../ui/components/SectionHeading";
import LocationPicker from "./LocationPicker";

const ContactStep = ({
  transactionalMobile,
  setTransactionalMobile,
  transactionalEmail,
  setTransactionalEmail,
  shopNumber,
  setShopNumber,
  buildingName,
  setBuildingName,
  streetAddress,
  setStreetAddress,
  contactCity,
  setContactCity,
  contactDistrict,
  setContactDistrict,
  contactState,
  setContactState,
  contactPinCode,
  setContactPinCode,
  shippingLatitude,
  shippingLongitude,
  setShippingLatitude,
  setShippingLongitude,
  shippingLocation,
  setShippingLocation,
  errors,
  setErrors,
}) => {
  const { getCurrentPosition, getAddressFromCoords, isCapacitor } =
    useGeoLocation();

  return (
    <div className="step-content">
      <SectionHeading>Transactional Contact</SectionHeading>
      <div className="form-row">
        <div className="form-group">
          <label htmlFor="Mobile">
            Mobile
          </label>
          <input
            id="Mobile"
            type="tel"
            pattern="[0-9]{10}"
            maxLength={10}
            placeholder="10-digit mobile number"
            value={transactionalMobile}
            onChange={(e) => setTransactionalMobile(e.target.value)}
            error={errors.transactionalMobile}
          />
        </div>
        <div className="form-group">
          <label htmlFor="Email">
            Email
          </label>
          <input
            id="Email"
            type="text"
            placeholder="business@example.com"
            value={transactionalEmail}
            onChange={(e) => setTransactionalEmail(e.target.value)}
            autoComplete="email"
            error={errors.transactionalEmail}
          />
        </div>
      </div>
      <SectionHeading style={{ marginTop: "40px" }}>
        Shipping Address
      </SectionHeading>

      <LocationPicker
        shippingLatitude={shippingLatitude}
        setShippingLatitude={setShippingLatitude}
        shippingLongitude={shippingLongitude}
        setShippingLongitude={setShippingLongitude}
        shippingLocation={shippingLocation}
        setShippingLocation={setShippingLocation}
        errors={errors}
        setErrors={setErrors}
        getCurrentPosition={getCurrentPosition}
        getAddressFromCoords={getAddressFromCoords}
        isCapacitor={isCapacitor}
        setShopNumber={setShopNumber}
        setBuildingName={setBuildingName}
        setStreetAddress={setStreetAddress}
        setContactCity={setContactCity}
        setContactDistrict={setContactDistrict}
        setContactState={setContactState}
        setContactPinCode={setContactPinCode}
      />
      <div className="form-row">
        <div className="form-group">
          <label htmlFor="shopNumber">Shop Number / Flat Number</label>
          <input
            id="shopNumber"
            value={shopNumber}
            onChange={(e) => setShopNumber(e.target.value)}
            error={errors.shopNumber}
          />
        </div>
        <div className="form-group">
          <label htmlFor="buildingName">Building Name</label>
          <input
            id="buildingName"
            value={buildingName}
            onChange={(e) => setBuildingName(e.target.value)}
            error={errors.buildingName}
          />
        </div>
      </div>
      <div className="form-row">
        <div className="form-group">
          <label htmlFor="streetAddress">Street Address</label>
          <input
            id="streetAddress"
            value={streetAddress}
            onChange={(e) => setStreetAddress(e.target.value)}
            error={errors.streetAddress}
          />
        </div>
        <div className="form-group">
          <label htmlFor="contactCity">City / Village</label>
          <input
            id="contactCity"
            value={contactCity}
            onChange={(e) => setContactCity(e.target.value)}
            error={errors.contactCity}
          />
        </div>
      </div>
      <div className="form-row">
        <div className="form-group">
          <label htmlFor="contactDistrict">
            District
          </label>
          <input
            id="contactDistrict"
            type="text"
            placeholder="Auto-filled from location"
            value={contactDistrict}
            onChange={(e) => setContactDistrict(e.target.value)}
          />
        </div>
        <div className="form-group">
          <label htmlFor="contactState">State</label>
          <input
            id="contactState"
            type="text"
            value={contactState}
            onChange={(e) => setContactState(e.target.value)}
            error={errors.contactState}
            placeholder="Enter State"
          />
        </div>
      </div>
      <div className="form-group">
        <label htmlFor="contactPinCode">
          Pincode
        </label>
        <input
          id="contactPinCode"
          type="text"
          maxLength={6}
          value={contactPinCode}
          onChange={(e) =>
            setContactPinCode(e.target.value.replace(/[^0-9]/g, ""))
          }
          error={errors.contactPinCode}
        />
      </div>
    </div>
  );
};

export default React.memo(ContactStep);
